<section
  class="bg-zinc-900 bg-cover bg-no-repeat bg-center"
  style="background-image: url('assets/images/auth-bg.svg')"
>
  <div class="flex flex-col items-center justify-center px-6 py-8 mx-auto h-screen lg:py-0">
    <div class="flex items-center mb-6">
      <img class="h-20" src="assets/images/logo-logame.svg" alt="logo" width="300">
    </div>
    <div class="w-full md:mt-0 sm:max-w-xl xl:p-0">
      <router-outlet />
    </div>
  </div>
</section>
